import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

export default function ClubContactCard({ displayName, email, phone }) {
  return (
    <section
      className="club-sidebar-card club-contact-card"
      aria-labelledby="club-contact-heading"
    >
      <h2
        id="club-contact-heading"
        className="club-sidebar-card__title club-sidebar-card__title--light mb-0"
      >
        Contact Info
      </h2>
      <div className="club-sidebar-card__body">
        <p
          className="mb-0"
          style={{
            color: colors.violate,
            fontWeight: 600,
            fontSize: "0.98rem",
          }}
        >
          {displayName}
        </p>
        <div className="club-sidebar-card__actions">
          <div className="d-flex gap-3 flex-wrap">
            {email ? (
              <a
                href={`mailto:${email}`}
                className="club-contact-icon"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  border: `2px solid ${colors.violate}`,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: colors.violate,
                  textDecoration: "none",
                  transition: "background 0.2s ease, transform 0.15s ease",
                }}
                aria-label="Email"
              >
                ✉
              </a>
            ) : (
              <span
                className="d-inline-flex align-items-center justify-content-center"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  border: `2px solid ${colors.violate}`,
                  color: colors.violate,
                  opacity: 0.4,
                }}
              >
                ✉
              </span>
            )}
            {phone ? (
              <a
                href={`tel:${phone}`}
                className="club-contact-icon"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  border: `2px solid ${colors.violate}`,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: colors.violate,
                  textDecoration: "none",
                  transition: "background 0.2s ease, transform 0.15s ease",
                }}
                aria-label="Phone"
              >
                📞
              </a>
            ) : (
              <span
                className="d-inline-flex align-items-center justify-content-center"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  border: `2px solid ${colors.violate}`,
                  color: colors.violate,
                  opacity: 0.4,
                }}
              >
                📞
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
